<template>
  <v-dialog
      v-model="dialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
  >
       <v-card>
           <v-card-title primary-title class="letter-spacing">
               Dodawanie zawodnika
           </v-card-title>
           <v-card-text class="py-2">
               <v-form v-model="valid">
                   <v-row no-gutters>
                       <v-col cols="12" class="py-0">
                             <v-select
                                :items="zawodnicy"
                                v-model="form.zawodnik"
                                label="Zawodnik"
                                outlined
                                dense
                                :error-messages="errors.zawodnik"
                           ></v-select>
                       </v-col>
                   </v-row>
               </v-form>
           </v-card-text>
           <v-card-actions class="pt-0">
               <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="grey"
                        class="text-none letter-spacing"
                        @click="dialog = false"
                    >
                        Anuluj
                    </v-btn>
                    <v-btn
                        elevation="0"
                        color="primary"
                        class="text-none"
                        @click="sendForm"
                        :disabled="form.zawodnik == ''"
                    >
                        Dodaj
                    </v-btn>
           </v-card-actions>

       </v-card>
  </v-dialog>
</template>

<script>
import dialog from '@/mixins/dialog.js';

export default {
    mixins: [dialog],
    props:{
        osiagniecie: {
            required: true,
        }
    },
    data: () => ({
        valid: false,
        menu: false,
        form: {
            zawodnik: '',
        },
        errors:{
            zawodnik: '',
        },
        zawodnicy:[
            {'text': 'Brak zawodników', value: -1}
        ]
    }),
    watch:{
        osiagniecie(){
            this.fetchZawodnicy();
        }
    },
    methods:{
        sendForm: function(){
            this.$http.post('/osiagniecia/addUczen', {
                    osiagniecie: this.$props.osiagniecie.id,
                    uczen: this.form.zawodnik
                })
                .then(() => {
                    this.dialog = false;
                    this.$emit('created');
                })
                .catch(err => {
                    this.errors = err.response.data.body;
                })
        },
        fetchZawodnicy: function(){
             this.$http.post('/uczniowie/selectList', {
                    osiagniecie: this.$props.osiagniecie.id
                })
                .then(res => {
                    this.zawodnicy = res.data.body;
                })
        },
        clearForm: function(){
            this.form = {
                zawodnik: '',
            };
            this.errors = {
                zawodnik: '',
            };
        }
    },
}
</script>

<style>

</style>